// extracted by mini-css-extract-plugin
export default {"switcher_container":"index_switcher_container__3IGPy","switcher_container1":"index_switcher_container1__BhP1S"};